// src/ConfigProvider/theme.tsx
import React, { useContext } from "react";
var ThemeTypeMap = {
  DARk: "dark",
  LIGHT: "light"
};
var DEFAULT_THEME = ThemeTypeMap.LIGHT;
var ThemeContext = React.createContext(DEFAULT_THEME);
var ThemeContextProvider = ({
  children,
  theme
}) => {
  const originTheme = React.useContext(ThemeContext);
  return /* @__PURE__ */ React.createElement(ThemeContext.Provider, { value: theme || originTheme }, children);
};
var useTheme = () => {
  const theme = useContext(ThemeContext);
  return [
    theme === ThemeTypeMap.DARk ? theme : ThemeTypeMap.LIGHT,
    theme === ThemeTypeMap.DARk ? "bds-theme-component-dark" : "bds-theme-component-light"
  ];
};
var theme_default = ThemeContext;
export {
  ThemeContextProvider,
  theme_default as default,
  useTheme
};
